export default function NotFound() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 64,
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      >
        404 페이지를 찾을수 없습니다.
      </div>
    );
  };